import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaShoppingCart, FaBars, FaTimes } from 'react-icons/fa';
import { useCart } from '../context/CartContext';
import { useWishlist } from '../context/WishlistContext';
import './Header.css';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const isLoggedIn = localStorage.getItem('token');
  const cliente = JSON.parse(localStorage.getItem('cliente') || '{}');
  const isAdmin = !!cliente?.is_admin;
  const { totalItems } = useCart();
  const { count: wishlistCount } = useWishlist();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('cliente');
    navigate('/');
    window.location.reload();
  };

  return (
    <header className="header">
      <div className="top-bar">
        <div className="container">
          <div className="top-bar-left">
            {isLoggedIn ? (
              <Link to="/minha-conta">Minha Conta</Link>
            ) : (
              <Link to="/login">Minha Conta</Link>
            )}
            <Link to="/lista-desejos">Lista de Desejos {wishlistCount > 0 && `(${wishlistCount})`}</Link>
            <Link to="/carrinho">Meu Carrinho {totalItems > 0 && `(${totalItems})`}</Link>
            <Link to="/checkout">Checkout</Link>
            {!isLoggedIn ? (
              <Link to="/login">Login</Link>
            ) : (
              <button onClick={handleLogout} className="logout-btn">Sair</button>
            )}
          </div>
        </div>
      </div>

      <div className="main-header">
        <div className="container">
          <div className="header-content">
            <Link to="/" className="logo">
              <span className="logo-highlight">Loucas</span> por Beleza
            </Link>

            <nav className={`nav ${menuOpen ? 'nav-open' : ''}`}>
              <Link to="/" onClick={() => setMenuOpen(false)}>HOME</Link>
              <Link to="/produtos" onClick={() => setMenuOpen(false)}>PRODUTOS</Link>
              <Link to="/lancamentos" onClick={() => setMenuOpen(false)}>LANÇAMENTOS</Link>
              <Link to="/cadastro-cliente" onClick={() => setMenuOpen(false)}>CADASTRAR CLIENTE</Link>
              {isAdmin && (
                <Link to="/admin/dashboard" onClick={() => setMenuOpen(false)}>ÁREA ADMIN</Link>
              )}
            </nav>

            <div className="header-actions">
              <Link to="/carrinho" className="cart-icon">
                <FaShoppingCart />
                <span>Carrinho</span>
                {totalItems > 0 && <span className="cart-badge">{totalItems}</span>}
              </Link>
              <button 
                className="menu-toggle"
                onClick={() => setMenuOpen(!menuOpen)}
                aria-label="Toggle menu"
              >
                {menuOpen ? <FaTimes /> : <FaBars />}
              </button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;

